// FILE: src/components/CoachRail.js
//
// Right-side sticky coaching column on desktop; collapses to a stacked
// section under the primary column on narrow screens.
//
// Composes its child cards but doesn't fetch data — the parent (LearnerDashboard)
// wires the props from the same readiness / sessions / activity state it
// already has loaded.

import React from 'react';
import styles from './CoachRail.module.css';
import CoachInsightCard from './CoachInsightCard';
import CoachSaysCard from './CoachSaysCard';
import FocusAreasCard from '../dashboard/FocusAreasCard';
import SecondaryDimensionCard from '../dashboard/SecondaryDimensionCard';
import NextSessionCard from '../dashboard/NextSessionCard';
import StreakCard from '../dashboard/StreakCard';
import QuickLinksCard from '../dashboard/QuickLinksCard';

export default function CoachRail({
  examLabel,
  examId,
  readiness,
  trend,
  weakPhases,
  secondaryPerformance,
  secondaryGuidance,
  activity,
  streak,
  onStartSession,
  onNavigate,
  onRecalibrate,
}) {
  return (
    <aside className={styles.rail} data-testid="dashboard-coach-rail">
      <CoachInsightCard
        examLabel={examLabel}
        readiness={readiness}
        trend={trend}
      />
      <CoachSaysCard
        readiness={readiness}
        trend={trend}
        secondaryGuidance={secondaryGuidance}
      />
      <FocusAreasCard
        weakPhases={weakPhases}
        onViewDetails={() => onNavigate?.('readiness')}
      />
      {/* Self-gates on getSecondaryDimension(examId): renders null for certs
          with no secondary dimension (pmp / cpmai / pmi-acp). */}
      <SecondaryDimensionCard
        examId={examId}
        performance={secondaryPerformance}
        onViewDetails={() => onNavigate?.('readiness')}
      />
      <NextSessionCard
        activity={activity}
        onStartSession={onStartSession}
      />
      <StreakCard streak={streak} />
      <QuickLinksCard onNavigate={onNavigate} onRecalibrate={onRecalibrate} />
    </aside>
  );
}
